import type { ReactNode } from 'react';
import { cn } from '../../utils/cn';
import LoadingSpinner from './LoadingSpinner';

type LoadingProps = {
    className?: string;
    size?: number;
    label?: ReactNode;
};

export default function Loading({ className, size = 32, label }: LoadingProps) {
    return (
        <div
            className={cn('flex flex-col items-center justify-center gap-3', className)}
            role='status'
            aria-live='polite'
            aria-busy='true'
        >
            <LoadingSpinner
                size={size}
                className='animate-[spin_0.85s_linear_infinite]'
            />
            {label ? <span className='text-sm text-[#4F4F4F]'>{label}</span> : null}
        </div>
    );
}
